<template>
  <notice-bar />

  <v-app-bar elevation="1">
    <template v-slot:prepend>
      <v-app-bar-nav-icon
        @click="storeLeftNav.isRailOpen = !storeLeftNav.isRailOpen"
        class="d-sm-none"
      ></v-app-bar-nav-icon>
      <v-btn @click="navigateTo('/')" :ripple="false">
        <v-img src="/images/logo/logo.png" width="160" class="mx-3"></v-img>
        <!-- <v-chip size="x-small" color="red" label class="align-self-start">SHOW</v-chip> -->
        <!-- <v-chip size="x-small" color="red" label>SHOW</v-chip> -->
      </v-btn>
    </template>

    <v-container fluid class="d-none d-sm-flex justify-space-around">
      <!--
      <v-row v-if="systemBar.systemMsgText">
        <v-col>
          <template v-if="systemBar.systemMsgText">
            <v-icon icon="mdi-message" class="me-2"></v-icon>
            <span>{{ systemBar.systemMsgText }} styles in staging</span>
          </template>
        </v-col>
      </v-row>
      -->
      <div></div>
      <div></div>
      <v-btn
        v-for="(n, i) in storeLeftNav.nav"
        :key="`${i}-a`"
        v-show="!n.groups || n.groups.includes(userData.userGroup)"
        :prepend-icon="n.icon"
        :to="!n.subItems ? n.to : null"
        :href="n.url"
        :target="n.url ? '_blank' : ''"
      >
        {{ displayUse.mdAndDown.value ? null : n.label }}
        <v-menu v-if="n.subItems && (!n.groups || n.groups.includes(userData.userGroup))" activator="parent">
          <v-list>
            <v-list-item
              v-for="(s, y) in n.subItems"
              :key="`${y}-c`"
              :to="s.to"
              :title="s.label"
              @click="clearPage(s.to)"
            />
          </v-list>
        </v-menu>
      </v-btn>
      <div></div>
      <div></div>
    </v-container>

    <div
      v-if="isLoggedIn()"
      :style="displayUse.mdAndDown.value ? 'min-width: 130px;' : 'min-width: 200px; max-width: 200px'"
    >
      <v-text-field
        v-model="searchValue"
        label="Style No"
        clearable
        density="compact"
        variant="underlined"
        append-inner-icon="mdi-magnify"
        class="ml-0"
        hide-details
        @keydown.enter="searchWithSearchValue"
        @click:appendInner="searchWithSearchValue"
        @click:clear.stop="clear"
      >
      </v-text-field>
    </div>
    <div v-if="isLoggedIn()" style="font-size: 0.9rem; width: 250px" class="d-none d-sm-block text-right mr-3">
      <p>Hello, {{ userData.customerCode }}</p>
      <p v-if="userData.selectedShowCustomer?.code" style="font-size: 0.8rem">
        Behalf of
        <v-chip size="x-small" :color="userData.selectedShowCustomer.status == 'ACTIVE' ? 'green' : 'red'" label>{{
          userData.selectedShowCustomer.code
        }}</v-chip>
      </p>
    </div>

    <v-menu v-if="isLoggedIn()">
      <template v-slot:activator="{ props }">
        <v-btn class="text-capitalize ml-3" size="comfortable" icon="mdi-account-circle" v-bind="props"></v-btn>
      </template>
      <v-list density="compact" nav class="text-center">
        <v-list-item title="My Account" @click="showMyAccount" v-if="!userStore.isGuestMode"></v-list-item>
        <v-list-item title="My Orders" @click="gotoMyOrders" v-if="!userStore.isReadOnlyCustomerMode"></v-list-item>
        <v-list-item title="Logout" @click="checkLogout"></v-list-item>
      </v-list>
    </v-menu>

    <!-- Temporarily hidden - grand total toggle button, kept for future re-use
    <v-btn v-if="isLoggedIn() && !userStore.isReadOnlyCustomerMode" @click="togleGrandTotal()" icon>
      <v-icon :icon="userData.isHideGrandTotal ? 'mdi-currency-usd-off' : 'mdi-currency-usd'"></v-icon>
    </v-btn>
    -->

    <v-btn
      v-if="isLoggedIn() && isShowCustomerSelected() && !userStore.isReadOnlyCustomerMode"
      @click="openCart()"
      icon
    >
      <v-badge color="error" :content="cartStore.cartItemCount">
        <v-icon>mdi-cart</v-icon>
      </v-badge>
    </v-btn>
  </v-app-bar>

  <!-- For Mobile Drawer -->
  <v-navigation-drawer v-model="storeLeftNav.isRailOpen" app temporary class="d-sm-none">
    <v-list v-model:opened="open" density="compact" nav @click="storeLeftNav.isRailOpen = false">
      <template v-for="(n, i) in storeLeftNav.nav">
        <v-list-item
          v-if="!n.subItems"
          v-show="!n.groups || n.groups.includes(userData.userGroup)"
          :key="`${i}-a`"
          :to="n.to"
          link
          :prepend-icon="n.icon"
          :title="n.label"
          @click="clearPage(n.to)"
        ></v-list-item>

        <v-list-group
          v-if="n.subItems"
          v-show="!n.groups || n.groups.includes(userData.userGroup)"
          :key="`${i}-b`"
          :value="i + '_' + n.label"
        >
          <template #activator="{ props }">
            <v-list-item
              v-show="!n.groups || n.groups.includes(userData.userGroup)"
              v-bind="props"
              :prepend-icon="n.icon"
              :title="n.label"
              @click="storeLeftNav.isRailOpen = true"
            ></v-list-item>
          </template>
          <template v-for="(s, y) in n.subItems">
            <v-list-item
              v-if="!s.subItems"
              v-show="!s.groups || s.groups.includes(userData.userGroup)"
              :key="`${y}-c`"
              :to="s.to"
              link
              :prepend-icon="s.icon"
              :title="s.label"
              @click="clearPage(s.to)"
            >
              <template #append v-if="s.badge?.value && !!storeLeftNav.badgeValues[s.badge?.value]">
                <v-badge
                  :color="s.badge?.color || 'error'"
                  :content="storeLeftNav.badgeValues[s.badge?.value]"
                  inline
                ></v-badge>
              </template>
            </v-list-item>
            <v-list-group
              v-if="s.subItems"
              v-show="!s.groups || s.groups.includes(userData.userGroup)"
              :key="`${y}-d`"
              :value="y + '__' + s.label"
            >
              <template #activator="{ props }">
                <v-list-item
                  v-show="!s.groups || s.groups.includes(userData.userGroup)"
                  v-bind="props"
                  :prepend-icon="s.icon"
                  :title="s.label"
                ></v-list-item>
              </template>
              <template v-for="(t, z) in s.subItems">
                <v-list-item
                  v-if="!t.subItems"
                  v-show="!t.groups || t.groups.includes(userData.userGroup)"
                  :key="`${z}-e`"
                  :to="t.to"
                  link
                  :prepend-icon="t.icon"
                  :title="t.label"
                  class="ml-4"
                  @click="clearPage(t.to)"
                ></v-list-item>
              </template>
            </v-list-group>
          </template>
        </v-list-group>
      </template>
    </v-list>
  </v-navigation-drawer>

  <v-snackbar
    v-model="systemBar.snackbar"
    v-if="systemBar.snackbarText != null"
    :timeout="systemBar.snackbarTimeout"
    elevation="24"
    location="center"
    vertical
  >
    {{ systemBar.snackbarText }}
    <template v-slot:actions>
      <v-btn color="pink" variant="text" @click="systemBar.snackbar = false"> Close </v-btn>
    </template>
  </v-snackbar>

  <v-dialog v-model="logoutDialog" width="auto">
    <v-card>
      <v-card-title class="text-center"> {{ userData.firstName }}, </v-card-title>
      <v-card-subtitle> </v-card-subtitle>
      <v-card-text> Are you sure you want to log out? </v-card-text>
      <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn variant="tonal" color="red" @click="dialog = false">Yes</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false">No</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions> -->

      <v-card-actions>
        <v-btn class="text-none mb-0" color="red-darken-3" size="large" variant="flat" block @click="logout">Yes</v-btn>
      </v-card-actions>
      <v-card-actions>
        <v-btn block class="text-none" color="grey-lighten-3" size="large" variant="flat" @click="logoutDialog = false"
          >No</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>

  <user-account-dialog ref="accountDialogRef"> </user-account-dialog>

  <confirm-dialog
    ref="confirmDialogRef"
    title="Logout"
    content="Are you sure you want to log out?"
    :hide-button="true"
    :use-yes-no="true"
    :show-cancel="false"
    :show-alert="true"
    @confirm:ok="logout"
  ></confirm-dialog>
</template>

<script setup>
// import, props, emits, use
useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} - JOVANI` : 'JOVANI'
  }
})
import { useDisplay } from 'vuetify'
const appConfigStore = useAppConfigStore()
const appConfig = appConfigStore.appConfig
//const { width, mobile } = useDisplay()
const displayUse = useDisplay()
const systemBar = useSystemBarStore()
const { userData, isLoggedIn, refreshHideGrandTotal } = useUserStore()
const userStore = useUserStore()
const { pageData } = usePageData()
const storeLeftNav = useLeftNavStore()
const cartStore = useCartStore()
const { showSnackbar } = useSnackbarStore()

// data
const logoutDialog = ref(false)
const accountDialogRef = shallowRef()
const confirmDialogRef = shallowRef()
const open = ref([])

const searchValue = ref('')
const searchWithSearchValue = async () => {
  if (searchValue.value.length < 3) {
    showSnackbar({ errorMessage: `The minimum search keyword length is 3.` })
    return
  }
  const _searchValue = g.deepCopy(searchValue.value.trim())
  searchValue.value = ''
  navigateTo({
    path: `/inventory/style/${g.urlEncode(_searchValue)}`
  })
}
const clear = () => {
  searchValue.value = ''
}

// computed

onMounted(async () => {
  // console.log(
  //   `> Header - onMounted`,
  //   isLoggedIn(),
  //   displayUse.width.value,
  //   displayUse.md.value,
  //   displayUse.mdAndDown.value
  // )
  if (isLoggedIn() && isShowCustomerSelected()) cartStore.refreshCartItemCount()
})

// method
const isShowCustomerSelected = () => {
  if (userStore.isSalesRep) return !!userStore.userData.selectedShowCustomer?.code
  return true
}
const logout = () => {
  logoutDialog.value = false
  navigateTo('/logout')
}
const openCart = () => {
  navigateTo('/cart')
}
const togleGrandTotal = () => {
  const isHideGrandTotalCookie = useCookie('isHideGrandTotal')
  isHideGrandTotalCookie.value = !(isHideGrandTotalCookie.value ?? true)
  nextTick(() => {
    refreshHideGrandTotal()
    /*
      setTimeout(() => {
        navigateTo(redirectUrl ?? '/catalog')
      }, 100)
      */
  })
}
const gotoMyOrders = () => {
  navigateTo('/myorders')
}
const showMyAccount = () => {
  accountDialogRef.value.init()
}

const checkLogout = async () => {
  const result = await confirmDialogRef.value.confirm()
  if (result === 'yes') logout()
}

const clearPage = (toPath) => {
  pageData.page = 1

  if (toPath !== window.location.pathname) {
    pageData.itemsPerPage = 15
  }
}
</script>

<style scoped></style>
